var exports = {
  "kL": "x31de4314--ef1e94--container",
  "iE": "x31de4314--ef1e94--wrapper",
  "DD": "x31de4314--ef1e94--title",
};

module.exports = exports;
